import { combineReducers } from "@reduxjs/toolkit";
import authReducer from "./auth/reducers";
import subscriptionReducer from "./subscription/reducers";
import profileReducer from "./profile/reducers";
import characterReducer from "./characterSetting/reducers";
import languageReducer from "./language/reducers";
import tokenReducer from "./tokenpackage/reducers";
import pageReducer from "./pages/reducers";
import userReducer from "./users/reducers";
import settingReducer from "./settings/reducer";
import transactionReducer from "./transaction/reducers";
import homeReducer from "./homePage/reducer";
import characterListReducer from "./character/reducers";
import RavenueListReducer from "./revenue/reducers";
import PaymentDataReducer from "./payments/reducers";
import AppearanceReducer from "./appearance/reducers";
import CharacterStyleReducer from "./characterStyle/reducers";
import DashboardReducer from "./dashboard/reducers";
import RequestReducer from "./requests/reducers";


const rootReducer = combineReducers({
  Auth: authReducer,
  Profile: profileReducer,
  Character: characterReducer,
  Language: languageReducer,
  Token: tokenReducer,
  Pages: pageReducer,
  User: userReducer,
  Subscription: subscriptionReducer,
  Setting: settingReducer,
  Transaction: transactionReducer,
  Home: homeReducer,
  CharacterList: characterListReducer,
  RevenueList: RavenueListReducer,
  PaymentData: PaymentDataReducer,
  Appearance: AppearanceReducer,
  CharType: CharacterStyleReducer,
  DashBoard: DashboardReducer,
  Requests: RequestReducer,
});

export default rootReducer;
